var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 1.25C22.4147 1.25 22.7505 1.58579 22.7505 2V22C22.7505 22.4142 22.4147 22.75 22.0005 22.75C21.5863 22.75 21.2505 22.4142 21.2505 22V2C21.2505 1.58579 21.5863 1.25 22.0005 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1041 7.44506C14.8845 7.24537 14.5677 7.19403 14.2962 7.31413C14.0247 7.43423 13.8496 7.70315 13.8496 8.00001V11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H13.8496V16C13.8496 16.2969 14.0247 16.5658 14.2962 16.6859C14.5677 16.806 14.8845 16.7547 15.1041 16.555L19.5041 12.555C19.6605 12.4128 19.7496 12.2113 19.7496 12C19.7496 11.7887 19.6605 11.5872 19.5041 11.4451L15.1041 7.44506Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftRight);
export default __webpack_public_path__ + "static/media/shift-right.d9fcd6d1c0a75d4bf88f7dbc7b754efe.svg";
export { ForwardRef as ReactComponent };